import React from 'react';
import { useNavigate } from 'react-router-dom';
import HeroBanner from './HeroBanner';
import { categories } from '../data/productsData';
import warehouseImg from '../assets/images/hero/warehouse-operations.jpg';
import './Home.css';

const Home = () => {
  const navigate = useNavigate();

  const handleCategoryClick = (categorySlug) => {
    navigate(`/products/${categorySlug}`);
  };

  return (
    <div className="home-page">
      {/* Hero Banner */}
      <HeroBanner />

      {/* Journey Section */}
      <section className="home-journey">
        <div className="container">
          <h2 className="section-title">Our Journey</h2>
          <div className="journey-steps">
            <div className="journey-step">
              <div className="journey-icon">🌾</div>
              <h3>Source</h3>
              <p>Naturally grown products sourced from trusted farmers.</p>
            </div>
            <div className="journey-arrow">→</div>
            <div className="journey-step">
              <div className="journey-icon">⚙️</div>
              <h3>Process</h3>
              <p>Carefully cleaned, processed, and packed under hygienic conditions.</p>
            </div>
            <div className="journey-arrow">→</div>
            <div className="journey-step">
              <div className="journey-icon">🚢</div>
              <h3>Export</h3>
              <p>Prepared for international shipment with export-grade packaging.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Product Categories Grid */}
      <section className="home-categories">
        <div className="container">
          <h2 className="section-title">Our Product Categories</h2>
          <p className="section-subtitle">Comprehensive range of premium agro products</p>
          
          <div className="categories-grid">
            {categories.map(category => (
              <div 
                key={category.id} 
                className="category-card"
                onClick={() => handleCategoryClick(category.slug)}
              >
                <div className="category-image">
                  <img src={category.image} alt={category.name} />
                </div>
                <h3>{category.name}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why we2 exporters */}
      <section className="home-why">
        <div className="why-split-container">
          <div className="why-left">
            <h2>Why we2 exporters</h2>
            <p className="why-intro">Your trusted partner for premium agro exports from India.</p>
            <ul className="why-bullets">
              <li>
                <span className="check-icon">✔</span>
                <span>Wide agro product range</span>
              </li>
              <li>
                <span className="check-icon">✔</span>
                <span>Farmer-direct sourcing</span>
              </li>
              <li>
                <span className="check-icon">✔</span>
                <span>Export-grade packing</span>
              </li>
              <li>
                <span className="check-icon">✔</span>
                <span>Flexible bulk supply</span>
              </li>
              <li>
                <span className="check-icon">✔</span>
                <span>Honest business practices</span>
              </li>
            </ul>
          </div>
          <div className="why-right">
            <img 
              src={warehouseImg}
              alt="Warehouse and export operations"
            />
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="home-cta">
        <div className="cta-content">
          <h2>Ready to collaborate?</h2>
          <p className="cta-subtext">
            Partner with we2 exporters for premium agro products<br />
            sourced directly from trusted farmers across India.
          </p>
          <button className="cta-button" onClick={() => navigate('/contact')}>
            Contact Us
          </button>
        </div>
      </section>
    </div>
  );
};

export default Home;
